module.exports = __webpack_public_path__ + "static/apple-a012f02d94c6418d47a13b07cb434a40.jpg";